import { rootUrl } from '@/constants';
import axios from 'axios';

export type SubmitGetTestsData = {
  lang: string;
};

export type TestsData = {
  id: string;
  title: string;
  color: string;
  levels: {
    [score: number]: {
      title: string;
      color: string;
    };
  };
};

export type ResponseGetTestsData = TestsData[];

export const getTestsData = async (data: SubmitGetTestsData) => {
  const response = await axios.post(
    `${rootUrl}/psy-tests/list`,
    {
      lang: data.lang,
    },
    {
      params: {
        lang: data.lang,
      },
      headers: {
        lang: data.lang,
      },
    }
  );

  return response.data;
};
